import React from 'react';
import axios from 'axios';
import ProductImage from '../components/productImage'
import ProductDescription from '../components/productDescription'
import Breadcrumb from '../components/breadcrumb'
import FullWidthTrend from '../components/fullWidthTrend'
// import ProductSpec from '../components/productSpecBtn'
import CardTrend from '../components/cardTrend'
import ApertureGlazing from '../components/aperture-glazing'
import Select from 'react-select'
import InputNumber from 'rc-input-number'
import qs from 'qs'

class Door extends React.Component {
  _isMounted = false;
  state = {
    products: [],
    title: null,
    door: null,
    loading: true,
    sizes: null,
    quantity: 1,
    singleConstruction: false,
    showSizes: false,
    apertures: false,
    projectOverlay: false,
    imageRef: null,
    userProjects: null,
    selectedProject: null,
    createProject: false,
    projectName: '',
    projectDevelopmentName: '',
    projectClient: '',
    projectCreated: false,
    projectCreatedId: false,
    validationError: false,
    duplicateProduct: false,
    customSku: false,
    showMyCollection: false,
    duplicateProjectName: false,
    sampleAdded: false,
    printSpec: false,
    configId: null,
    proejctUpdated: false
  }

  prettify = (str) => {
    return str.split('-').map(function capitalize(part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ').replace('__', '/').replace('_', '-')
  }

  getProductData = () => {
    this.setState({
      loading: true
    });
    let nameEncoded = encodeURIComponent(this.prettify(this.props.match.params.doorName))
    let getProductURL = `${window.wpApiSettings.root}api/get-products-and-filters/?name=${nameEncoded}`

    axios.get(getProductURL)
      .then(res => {
        // console.log(res)
        const category = Object.keys(res.data.body.basicFilters)[0];
        const data = res.data.body.advancedFilters;
        const type = res.data.body.products[0].product_type;
        const imageRef = res.data.body.products[0].image_ref;
        const description = res.data.body.products[0].description;
        const soundsecure = res.data.body.soundsecure;
        const speedset = res.data.body.speedset;
        const has_sample = res.data.body.products[0].has_sample;
        const techRef = res.data.body.products[0].technical_ref;
        const option_plus = res.data.body.products[0].option_plus;
        let constructions = [];
        let sizes = [];
        let optionPlusOptions = [];


        data.construction.forEach(construction => {
          constructions.push({ value: construction, label: construction })
        })

        if (option_plus && option_plus.length > 0) {
          option_plus.forEach(option => {
            optionPlusOptions.push({ value: option, label: option })
          })
        }


        if (constructions.length === 1) {
          this.setState({
            singleConstruction: true,
            showSizes: true,
            selectedConstruction: constructions[0],
            selectedConstructionValue: constructions[0].value,
          })
          data.size.forEach(size => {
            sizes.push({ value: size, label: size })
          });
        }

        if (localStorage.getItem('sampleList')) {
          let sampleList = localStorage.getItem('sampleList')
          sampleList = JSON.parse(sampleList);
          sampleList.forEach(sample => {
            if (has_sample && has_sample === sample) {
              this.setState({ sampleAdded: true })
            }
          });
        }

        // prevents options from losing their values after product data load
        if (this.props.location.search.length <= 0) {
          this.setState({
            constructions,
            sizes,
            optionPlusOptions
          })
        }


        this.setState({
          constructions,
          loading: false,
          category,
          type,
          imageRef,
          description,
          soundsecure,
          speedset,
          has_sample,
          techRef,
        })
      })
  }

  filterConstruction = (construction) => {
    this.setState({
      loading: true
    });
    let nameEncoded = encodeURIComponent(this.prettify(this.props.match.params.doorName));
    let getProductURL = `${window.wpApiSettings.root}api/get-products-and-filters/?name=${nameEncoded}${construction ? `&construction=${construction}` : ``}&count=110`;
    axios.get(getProductURL)
      .then(res => {
        // console.log(res)
        const data = res.data.body.advancedFilters;
        let sizes = [];
        data.size.forEach(size => {
          sizes.push({ value: size, label: size })
        })

        this.setState({
          loading: false,
          sizes: sizes
        })
      })
  }

  filterSize = (size) => {
    this.setState({
      loading: true,
      apertures: [],
      glazing: null
    });
    let nameEncoded = encodeURIComponent(this.prettify(this.props.match.params.doorName))
    let getProductURL = `${window.wpApiSettings.root}api/get-products-and-filters/?name=${nameEncoded}${this.state.selectedConstructionValue ? `&construction=${this.state.selectedConstructionValue}` : ``}${size ? `&size=${size}` : ``}&count=110`;
    axios.get(getProductURL)
      .then(res => {
        let optionPlusOptions = [];
        const data = res.data.body;
        const option_plus = res.data.body.products[0].option_plus;
        const advancedFilters = data.advancedFilters;
        if (option_plus && option_plus.length > 0) {
          option_plus.forEach(option => {
            optionPlusOptions.push({ value: option, label: option })
          })
        }
        // console.log(optionPlusOptions)
        this.setState({
          loading: false,
          apertures: advancedFilters.design_codes,
          glazing: advancedFilters.glazing_types,
          productSku: data.products[0].sku_code,
          option_plus: optionPlusOptions.length > 0 ? true : false,
          optionPlusOptions
        })
      })
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({
        projectOverlay: false,
        proejctSuccess: false
      })
    }
  }

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener("keydown", this.escFunction, false);
    window.scrollTo(0, 0);
    axios.get(`${window.wpApiSettings.root}wp/v2/pages/${window.doorPage}`)
      .then(res => {
        // console.log(res)
        this.setState({
          acf: res.data.acf,
          loading: false
        });
      })
    this.setState({
      title: this.prettify(this.props.match.params.doorName)
    })
    if (this._isMounted) {
      this.getProductData();
      if (window.loggedIn) {
        this.getCurrentProjects();
      }
    }
    document.title = `Doors | ${this.prettify(this.props.match.params.doorName)}`;

    // check length of query string
    if (this.props.location.search.length > 0) {
      // removes first ? from query string
      const queries = this.props.location.search.slice(1);

      // parse queries into object using query string library
      const parsedQueries = qs.parse(queries)

      if ("configId" in parsedQueries) {
        if (parsedQueries["configId"]) {
          // to do set spec to state and load
          this.setState({ configId: parsedQueries["configId"] })
        }
      }
      if ("projectId" in parsedQueries) {
        if (parsedQueries["projectId"]) {
          // to do set spec to state and load
          this.setState({ selectedProject: { value: parsedQueries["projectId"] }, projectCreatedId: parsedQueries["projectId"] })
        }
      }

      if ("construction" in parsedQueries) {
        this.constructionChange({ label: parsedQueries["construction"], value: parsedQueries["construction"] });
      }

      if ("size" in parsedQueries) {
        this.sizeChange({ label: parsedQueries["size"], value: parsedQueries["size"] })
      }

      if ("quantity" in parsedQueries) {
        this.quantityChange(parsedQueries["quantity"])
      }

      if ("spec" in parsedQueries) {
        if (parsedQueries["spec"]) {
          // to do set spec to state and load
          this.setState({ printSpec: true })
        }
      }
      if ("img" in parsedQueries) {
        if (parsedQueries["img"]) {
          // to do set spec to state and load
          this.setState({ printDoorImg: parsedQueries["img"] })
        }
      }
      if ("sku" in parsedQueries) {
        if (parsedQueries["sku"]) {
          // to do set spec to state and load
          this.setState({ productSku: parsedQueries["sku"] })
        }
      }
      if ("custom-sku" in parsedQueries) {
        if (parsedQueries["custom-sku"]) {
          // to do set spec to state and load
          console.log(parsedQueries["custom-sku"])
          this.setState({ customSku: true, productSku: null })
        }
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("keydown", this.escFunction, false);
  }

  constructionChange = (selectedOption) => {
    if (this.props.location.search.length <= 0 || qs.parse(this.props.location.search.slice(1)).construction) {
      this.setState({
        selectedSizeValue: null,
        selectedSize: null,
      })
    }

    this.setState({
      selectedConstruction: selectedOption,
      selectedConstructionValue: selectedOption.value,
      showSizes: true,
      selectedAperture: null,
      selectedGlazing: null,
      customSku: false,
      selectedOptionPlus: null,
      option_plus: false,
      apertures: false,
      productSku: null,
    },
      () => {
        this.filterConstruction(this.state.selectedConstructionValue)
        this.props.history.push({
          search: `?${this.state.selectedConstructionValue ? `construction=${this.state.selectedConstructionValue}` : ''}${this.state.selectedSizeValue ? `&size=${this.state.selectedSizeValue}` : ''}${this.state.quantity ? `&quantity=${this.state.quantity}` : ''}${this.state.productSku ? `&sku=${this.state.productSku}` : ''}${this.state.customSku ? `&custom-sku=Custom Code` : ''}${this.state.configId ? `&configId=${this.state.configId}` : ``}${this.state.projectCreatedId ? `&projectId=${this.state.projectCreatedId}` : ``}`
        })
      })
  }

  sizeChange = (selectedOption) => {
    this.setState({
      selectedSize: selectedOption,
      selectedSizeValue: selectedOption.value,
      showMyCollection: true,
      selectedOptionPlus: null,
      selectedAperture: null,
      selectedGlazing: null,
      customSku: false,
      customHeight: null,
      customWidth: null
    },
      () => {
        this.filterSize(this.state.selectedSizeValue)
        this.props.history.push({
          search: `?${this.state.selectedConstructionValue ? `construction=${this.state.selectedConstructionValue}` : ''}${this.state.selectedSizeValue ? `&size=${this.state.selectedSizeValue}` : ''}${this.state.quantity ? `&quantity=${this.state.quantity}` : ''}${this.state.productSku ? `&sku=${this.state.productSku}` : ''}${this.state.customSku ? `&custom-sku=Custom Code` : ''}${this.state.configId ? `&configId=${this.state.configId}` : ``}${this.state.projectCreatedId ? `&projectId=${this.state.projectCreatedId}` : ``}`
        })
      });
  }

  oPChange = (selectedOP) => {
    this.setState({
      selectedOptionPlus: selectedOP
    }, () => this.checkCustomCode());
  }

  quantityChange = (value) => {
    this.setState({
      quantity: value
    }, () =>
      this.props.history.push({
        search: `?${this.state.selectedConstructionValue ? `construction=${this.state.selectedConstructionValue}` : ''}${this.state.selectedSizeValue ? `&size=${this.state.selectedSizeValue}` : ''}${this.state.quantity ? `&quantity=${this.state.quantity}` : ''}${this.state.productSku ? `&sku=${this.state.productSku}` : ''}${this.state.customSku ? `&custom-sku=Custom Code` : ''}${this.state.configId ? `&configId=${this.state.configId}` : ``}${this.state.projectCreatedId ? `&projectId=${this.state.projectCreatedId}` : ``}`
      })
    );

  }

  setAperture = (value) => {
    this.setState({
      selectedAperture: value
    }, () => this.checkCustomCode());
  }

  setGlazing = (value) => {
    this.setState({
      selectedGlazing: value
    }, () => this.checkCustomCode());
  }

  checkCustomCode = () => {
    let customCode = false;
    if (this.state.selectedAperture && this.state.selectedGlazing) {
      customCode = true
    }
    if (this.state.selectedOptionPlus && this.state.selectedOptionPlus.length > 0) {
      customCode = true
    }
    if (this.state.customHeight && this.state.customHeight !== '') {
      customCode = true
    }
    if (this.state.customWidth && this.state.customWidth !== '') {
      customCode = true
    }
    return this.setState({ customSku: customCode })
  }

  customHeight = (e) => {
    this.setState({
      customHeight: e.target.value
    }, () => this.checkCustomCode());
  }
  customWidth = (e) => {
    this.setState({
      customWidth: e.target.value,
    }, () => this.checkCustomCode());
  }

  projectChange = (option) => {
    if (option.value === 'create') {
      this.setState({
        createProject: true,
        selectedProject: option
      });
    } else {
      this.setState({
        createProject: false,
        selectedProject: option,
        projectCreatedId: option.value
      });
    }
  }


  getCurrentProjects = () => {
    axios({
      method: 'GET',
      url: `${window.wpApiSettings.root}api/get-projects/`,
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': window.wpApiSettings.nonce
      }
    }).then(res => {
      let userProjects = [{ value: 'create', label: '+ Add New Project' }];
      res.data.body.results.forEach(project => {
        if (this.state.projectCreatedId === Number(project.id)) {
          this.setState({
            selectedProject: { value: project.id, label: project.project_name }
          }, () => this.createConfiguration())
        }
        userProjects.push({ value: project.id, label: project.project_name })
      })

      this.setState({
        userProjects: userProjects
      })
    })
      .catch(function (error) {
        // console.log(error)
      })
  }

  createProject = () => {
    if (
      this.state.projectName.length > 0 &&
      this.state.projectDevelopmentName.length > 0 &&
      this.state.projectClient.length > 0
    ) {
      const data = {
        project_name: this.state.projectName,
        project_development_name: this.state.projectDevelopmentName,
        project_client: this.state.projectClient
      }
      axios({
        method: 'POST',
        url: `${window.wpApiSettings.root}api/add-project/`,
        headers: {
          dataType: 'json',
          contentType: 'application/json;charset=UTF-8',
          'X-WP-Nonce': window.wpApiSettings.nonce
        },
        data: qs.stringify(data)
      }).then(res => {
        if (res.data.data.status === 400) {
          this.setState({
            projectCreated: false,
            duplicateProjectName: true,
            createProject: false
          })
        } else {
          this.setState({
            projectCreated: true,
            projectCreatedId: res.data.body.insertedId
          }, () => this.getCurrentProjects())
        }

      })
        .catch(function (error) {
        });
    }
    else {
      this.setState({
        validationError: false
      })
    }
  }


  createConfiguration = () => {
    const data = {
      "label": this.prettify(this.props.match.params.doorName),
      "project_id": this.state.selectedProject ? this.state.selectedProject.value : null,
      "type": this.state.type,
      "construction": this.state.selectedConstruction ? this.state.selectedConstruction.value : null,
      "size": this.state.selectedSize ? this.state.selectedSize.value : null,
      "quantity": this.state.quantity,
      "sku": this.state.productSku ? this.state.productSku : null,
      "notes": this.state.customSku ? 'Custom Code' : null,
      "custom_width": this.state.customHeight ? this.state.customHeight : null,
      "custom_height": this.state.customHeight ? this.state.customHeight : null,
      "design_code": this.state.selectedAperture ? this.state.selectedAperture : null,
      "glazing_type": this.state.selectedGlazing ? this.state.selectedGlazing : null,
      "option_plus": this.state.selectedOptionPlus ? this.state.selectedOptionPlus.map(item => item.value).toString() : null,
      "image_ref": this.state.imageRef ? this.state.imageRef.split(',')[0] : null
    }
    // console.log(data)
    axios({
      method: 'POST',
      url: `${window.wpApiSettings.root}api/add-configuration/`,
      headers: {
        dataType: 'json',
        contentType: 'application/json;charset=UTF-8',
        'X-WP-Nonce': window.wpApiSettings.nonce
      },
      data: qs.stringify(data)
    }).then(res => {
      if (res.data.body.didInsert > 0) {
        this.setState({
          createProject: false,
          projectName: '',
          projectDevelopmentName: '',
          projectClient: '',
          proejctSuccess: true
        })
      } else if (res.data.data.status === 400) {
        this.setState({
          duplicateProduct: true
        });
      }
    })
      .catch(function (error) {
        // console.log(error)
      });
  }

  updateConfiguration = () => {
    const data = {
      "label": this.prettify(this.props.match.params.doorName),
      "project_id": this.state.selectedProject ? this.state.selectedProject.value : null,
      "type": this.state.type,
      "construction": this.state.selectedConstruction ? this.state.selectedConstruction.value : null,
      "size": this.state.selectedSize ? this.state.selectedSize.value : null,
      "quantity": this.state.quantity,
      "sku": this.state.productSku ? this.state.productSku : null,
      "notes": this.state.customSku ? 'Custom Code' : null,
      "custom_width": this.state.customHeight ? this.state.customHeight : null,
      "custom_height": this.state.customHeight ? this.state.customHeight : null,
      "design_code": this.state.selectedAperture ? this.state.selectedAperture : null,
      "glazing_type": this.state.selectedGlazing ? this.state.selectedGlazing : null,
      "option_plus": this.state.selectedOptionPlus ? this.state.selectedOptionPlus.map(item => item.value).toString() : null,
      "config_id": this.state.configId ? this.state.configId : null,
      "image_ref": this.state.imageRef ? this.state.imageRef.split(',')[0] : null
    }
    axios({
      method: 'POST',
      url: `${window.wpApiSettings.root}api/add-configuration/`,
      headers: {
        dataType: 'json',
        contentType: 'application/json;charset=UTF-8',
        'X-WP-Nonce': window.wpApiSettings.nonce
      },
      data: qs.stringify(data)
    }).then(res => {
      this.setState({ projectOverlay: true, proejctUpdated: true, proejctSuccess: true })
      // console.log(res)
    })
      .catch(function (error) {
        console.log(error)
      });
  }


  addProjectUpdate = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    }, () =>
      this.state.projectName.length > 0 &&
        this.state.projectDevelopmentName.length > 0 &&
        this.state.projectClient.length > 0
        ?
        this.setState({
          validationError: true
        })
        :
        this.setState({
          validationError: false
        })
    )
  }

  checkModalState = () => {
    const overlay = document.getElementsByClassName('overlay');
    if (overlay[0].classList.contains('active')) {
      this.setState({ projectOverlay: true })
    } else {
      this.setState({
        projectOverlay: false,
        duplicateProduct: false,
        duplicateProjectName: false,
        createProject: false,
        projectName: '',
        projectDevelopmentName: '',
        projectClient: ''
      })

    }
  }

  saveSample = (sample) => {
    if (sample) {
      let existing = localStorage.getItem('sampleList');
      if (existing) {
        existing = JSON.parse(existing);
      } else {
        existing = []
      }
      existing.push(sample);
      localStorage.setItem('sampleList', JSON.stringify(existing));
      this.setState({ sampleAdded: true })
    }
  }

  removeSample = (sample) => {
    if (sample) {
      let existing = localStorage.getItem('sampleList')
      existing = JSON.parse(existing);
      existing = existing.filter(e => e !== sample)
      if (existing.length <= 0) {
        localStorage.removeItem('sampleList')
      } else {
        localStorage.setItem('sampleList', JSON.stringify(existing));
      }

      this.setState({ sampleAdded: false })
    }
  }

  render() {
    if (this.state.printSpec) {
      return (
        <div></div>
        //   <ProductSpec
        //     immediateSave={true}
        //     productName={this.state.title ? this.state.title : null}
        //     doorImage={this.state.printDoorImg ? this.state.printDoorImg : null}
        //     construction={this.state.selectedConstruction ? this.state.selectedConstruction.value : null}
        //     size={this.state.selectedSize ? this.state.selectedSize.value : null}
        //     quantity={this.state.quantity ? this.state.quantity : 1}
        //     sku={this.state.productSku ? this.state.productSku  : null}
        //     customSku={this.state.customSku}
        //     customWidth={this.state.customHeight ? this.state.customHeight  : null}
        //     customHeight={this.state.customHeight ? this.state.customHeight  : null}
        //     designCode={this.state.selectedAperture ? this.state.selectedAperture  : null}
        //     glazingType={this.state.selectedGlazing ? this.state.selectedGlazing  : null}
        //     optionPlus={this.state.selectedOptionPlus ? this.state.selectedOptionPlus  : null}
        // />
      )
    } else {
      return (
        <React.Fragment>
          <div className='container'>
            <div className='row'>
              <div className='col-xs-12'>
                <Breadcrumb currentPage={this.state.title} />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-7 col-lg-8 product-details'>
                {this.state.imageRef && <ProductImage image={this.state.imageRef} name={this.state.title} />}
                {this.state.description && <ProductDescription description={this.state.description} soundsecure={this.state.soundsecure} speedset={this.state.speedset} />}
              </div>
              <div className='col-md-5 col-lg-4'>
                <div className='product-filters'>
                  {this.state.has_sample ?
                    <div>
                      {this.state.sampleAdded ?
                        <div className="btn sample-added btn--block" title="Sample Added" tabIndex="0" onClick={() => this.removeSample(this.state.has_sample)}>Sample Added<i className="remove-btn">X</i></div>
                        :
                        <div className="btn btn-sample btn--block" title="Request Sample" tabIndex="0" onClick={() => this.saveSample(this.state.has_sample)}>Request Colour Swatch Sample</div>
                      }
                    </div>
                    : null}

                  <h2>Specify your Door</h2>
                  {this.state.loading && <div className='loading-overlay'></div>}
                  <div className="form-group">
                    <label>Construction</label>
                    <Select autoFocus={false} className='react-select-container' classNamePrefix="react-select" options={this.state.constructions ? this.state.constructions : []} isDisabled={this.state.singleConstruction} isLoading={this.state.loading} onChange={this.constructionChange} value={this.state.selectedConstruction} />
                  </div>

                  <div className="form-group">
                    <label>Size</label>
                    <Select autoFocus={false} className='react-select-container' classNamePrefix="react-select" options={this.state.sizes ? this.state.sizes : []} isDisabled={!this.state.showSizes} isLoading={this.state.loading} onChange={this.sizeChange} value={this.state.selectedSize} />
                  </div>
                  {this.state.category && this.state.category !== 'French Door' && this.state.category !== 'Folding Door' &&
                    <div className="form-group">
                      <label>Non-Standard Size</label>
                      <div className="non-standard-size">
                        <input type="number" pattern="[0-9]*" min={1} className="form-control" value={this.state.customWidth || ''} onChange={this.customWidth} />
                        <span>
                          x
                        </span>
                        <input type="number" pattern="[0-9]*" min={1} className="form-control" value={this.state.customHeight || ''} onChange={this.customHeight} />
                        <span>
                          mm
                        </span>
                      </div>
                    </div>
                  }
                  {this.state.option_plus &&
                    <div className="form-group">
                      <label>Option Plus</label>
                      <Select autoFocus={false} isMulti className='react-select-container' classNamePrefix="react-select" options={this.state.optionPlusOptions} isLoading={this.state.loading} onChange={this.oPChange} value={this.state.selectedOptionPlus} />
                    </div>
                  }
                  {this.state.apertures && this.state.apertures.length > 0 &&
                    <div className="form-group">
                      <label>Aperture & Glazing</label>
                      <ApertureGlazing apertures={this.state.apertures} glazing={this.state.glazing} setAperture={this.setAperture} setGlazing={this.setGlazing} checkCustomCode={this.checkCustomCode} />
                    </div>
                  }
                  <div className="form-group">
                    <label>Quantity</label>
                    <InputNumber
                      min={1}
                      max={100}
                      value={this.state.quantity}
                      onChange={this.quantityChange}
                    />
                  </div>
                  {this.state.productSku &&
                    <div className="sku-code">
                      Product Code:  <span>{this.state.productSku && !this.state.customSku ? this.state.productSku : 'Custom Code'}</span>
                    </div>
                  }
                  {/*<div className="btn-group">*/}
                  {/*{this.state.imageRef &&*/}
                  {/*  <ProductSpec*/}
                  {/*    immediateSave={false}*/}
                  {/*    productName={this.state.title}*/}
                  {/*    doorImage={this.state.imageRef}*/}
                  {/*    construction={this.state.selectedConstruction ? this.state.selectedConstruction.value : null}*/}
                  {/*    size={this.state.selectedSize ? this.state.selectedSize.value : null}*/}
                  {/*    quantity={this.state.quantity}*/}
                  {/*    sku={this.state.productSku ? this.state.productSku  : null}*/}
                  {/*    customSku={this.state.customSku}*/}
                  {/*    customWidth={this.state.customHeight ? this.state.customHeight  : null}*/}
                  {/*    customHeight={this.state.customHeight ? this.state.customHeight  : null}*/}
                  {/*    designCode={this.state.selectedAperture ? this.state.selectedAperture  : null}*/}
                  {/*    glazingType={this.state.selectedGlazing ? this.state.selectedGlazing  : null}*/}
                  {/*    optionPlus={this.state.selectedOptionPlus ? this.state.selectedOptionPlus  : null}*/}
                  {/*  />*/}
                  {/*}*/}
                  {/*  {window.wpApiSettings.nonce &&*/}
                  {/*  <div className="save-btn-group">*/}
                  {/*  {window.loggedIn ?*/}
                  {/*    // check if item is being revised*/}
                  {/*    this.state.configId ?*/}
                  {/*    <div className="product-btn" onClick={() => this.updateConfiguration()}><i className="icn-save"></i>Update Product*/}
                  {/*      <a data-tip data-for='tooltip'>i</a>*/}
                  {/*    </div> :*/}
                  {/*    <div className="product-btn" onClick={() => this.setState({projectOverlay: true, proejctSuccess: false})}><i className="icn-save"></i>Save to My Collection*/}
                  {/*      <a data-tip data-for='tooltip'>i</a>*/}
                  {/*    </div>*/}
                  {/*    :*/}
                  {/*    <div onClick={() => {window.location = `${window.location.protocol}//${window.location.host}/wp-login.php?redirect_to=${window.location.href}`}} className="btn btn--lock"><i className="fas fa-lock"></i>Login to Save to My Collection*/}
                  {/*    <a data-tip data-for='tooltip'>i</a>*/}
                  {/*    </div>*/}
                  {/*  }*/}
                  {/*  <ReactTooltip id='tooltip' effect='solid' className='logo-tooltip'>*/}
                  {/*    <span>A handy way to create a project and email directly to a key distributor for pricing.</span>*/}
                  {/*  </ReactTooltip>*/}
                  {/*  </div>}*/}
                  {/*  {this.state.techRef && <a href={`https://masonite.uniformstaging.net/wp-content/themes/uniform_base/assets/documents/${this.state.techRef.replace(/\s+/g, '-')}.pdf`} target="_blank" rel="noopener noreferrer" className="btn btn--dark"><i className="icn-download"></i>Download Technical Documents</a>}*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-12 pl-md-0 pr-md-0'>
                {this.state.acf && this.state.acf.full_width_trend &&
                  <FullWidthTrend
                    image={this.state.acf.full_width_trend.image}
                    title={this.state.acf.full_width_trend.title}
                    sub_heading={this.state.acf.full_width_trend.sub_heading}
                    video_id={this.state.acf.full_width_trend.yt_video_id}
                  />
                }
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 col-xs-12 pl-md-0'>
                {this.state.acf &&
                  <CardTrend
                    image={this.state.acf.two_column_trend.left_column.image}
                    heading={this.state.acf.two_column_trend.left_column.heading}
                    sub_heading={this.state.acf.two_column_trend.left_column.sub_heading}
                    link={this.state.acf.two_column_trend.left_column.link}
                  />
                }
              </div>
              <div className='col-md-6 col-xs-12 pr-md-0'>
                {this.state.acf &&
                  <CardTrend
                    image={this.state.acf.two_column_trend.right_column.image}
                    heading={this.state.acf.two_column_trend.right_column.heading}
                    sub_heading={this.state.acf.two_column_trend.right_column.sub_heading}
                    link={this.state.acf.two_column_trend.right_column.link}
                  />
                }
              </div>
            </div>
          </div>

          <div className={`overlay overlay--white ${this.state.projectOverlay ? 'active' : ''}`}>
            <div className="overlay__outer" onClick={() => this.checkModalState()}>
              <div className="overlay__inner collection-modal">
                <span className="close-btn" onClick={() => this.checkModalState()}>
                  close
                </span>
                <div className="gform_heading">
                  <h3 className="gform_title">Add to your Collection</h3>
                </div>
                <div className="gform_body collections-modal">

                  {this.state.duplicateProduct &&
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                      <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      Product already added to project
                    </div>
                  }
                  {this.state.duplicateProjectName &&
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                      <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      Project already exists
                    </div>
                  }
                  {!this.state.proejctSuccess ?
                    <React.Fragment>
                      <h3>Choose a Project</h3>
                      <Select autoFocus={false} className='react-select-container' classNamePrefix="react-select" options={this.state.userProjects ? this.state.userProjects : []} onChange={this.projectChange} value={this.state.selectedProject} />
                      {this.state.createProject &&
                        <div className="form-group create-project">
                          <label>New Project Name</label>
                          <input type="text" className="form-control" name="projectName" value={this.state.projectName} onChange={this.addProjectUpdate} />
                          <label>New Project Development Name</label>
                          <input type="text" className="form-control" name="projectDevelopmentName" value={this.state.projectDevelopmentName} onChange={this.addProjectUpdate} />
                          <label>New Project Client</label>
                          <input type="text" className="form-control" name="projectClient" value={this.state.projectClient} onChange={this.addProjectUpdate} />
                        </div>}
                    </React.Fragment>
                    :
                    this.state.proejctUpdated ?
                      <div className="updated-success" role="alert">
                        Your door has been updated
                      </div> :
                      <div className="alert alert-success" role="alert">
                        {this.state.title} has been saved to your collections
                      </div>
                  }
                </div>
                <div className="gform_footer top_label">
                  {this.state.selectedProject && this.state.validationError && this.state.createProject && !this.state.projectCreated && !this.state.proejctSuccess && <div className="btn btn--green 1" onClick={() => this.createProject()}>Create Project and Save</div>}
                  {this.state.selectedProject && !this.state.createProject && !this.state.projectCreated && !this.state.proejctSuccess && <div className="btn btn--green 2" onClick={() => this.createConfiguration()}>Save to Project</div>}
                  {this.state.projectCreated && this.state.proejctSuccess && <a href={`/collections?id=${this.state.projectCreatedId}`} className="btn btn--green" >View Project</a>}
                  {this.state.proejctSuccess && !this.state.projectCreated && <a href={`/collections?id=${this.state.projectCreatedId}`} className="btn btn--green" >View Project</a>}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }
  }
}

export default Door;
